import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { CategoryService, EntryPoint, EntryPointService } from '@mirage-projects/cw-commons';
import { Category, ResultPage } from '@mirage-projects/cw-models';

@Injectable({
    providedIn: 'root',
})
export class AppCategoryService implements CategoryService {
    constructor(
        private http: HttpClient,
        private entryPointService: EntryPointService
    ) {}

    /**
     * Get the category by id
     * @param id Category id
     */
    getCategory(id: number): Observable<Category> {
        const entryPoint = this.entryPointService.getResource(EntryPoint.CATEGORIES, `${id}`);
        return this.http.get<Category>(`${entryPoint}`, {}).pipe(catchError((err) => throwError(() => new Error(err))));
    }

    /**
     * Get the list of categories
     */
    getCategoryList(): Observable<ResultPage<Category>> {
        const entryPoint = this.entryPointService.getResource(EntryPoint.CATEGORIES);
        return this.http
            .get<ResultPage<Category>>(`${entryPoint}?system=true`, {})
            .pipe(catchError((err) => throwError(() => new Error(err))));
    }
}
